import React, { useState } from "react";
import "./allUi.css";

function Tabs({ children, defaultValue, className }) {
  const [activeTab, setActiveTab] = useState(defaultValue || 0);

  return (
    <div className={`newdashboard-tabs ${className || ""}`}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { activeTab, setActiveTab })
      )}
    </div>
  );
}

function TabsList({ children, className, activeTab, setActiveTab }) {
  return (
    <div className={`newdashboard-tabs-list ${className || ""}`}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          index,
          isActive: activeTab === index,
          onClick: () => setActiveTab(index),
        })
      )}
    </div>
  );
}

function TabsTrigger({ children, isActive, onClick, className }) {
  return (
    <button
      onClick={onClick}
      className={`newdashboard-tabs-trigger ${
        isActive ? "newdashboard-tabs-trigger-active" : ""
      } ${className || ""}`}
    >
      {children}
    </button>
  );
}

function TabsContent({ children, activeTab, index, className }) {
  if (activeTab !== index) return null;
  return (
    <div className={`newdashboard-tabs-content ${className || ""}`}>
      {children}
    </div>
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };